import { AES_ENCRYPTION_SECRET_KEY, COOKIE_KEY } from '@config/constanta';
import Cookies from 'js-cookie';

import { checkPinToken as libCheckPinToken } from '@ajaibid/utils';
import { authStorage } from './storeHelper';

/**
 * The Helper funtion to validate the pin token against the stored token.
 * @returns {boolean} True if the pin token is valid. false otherwise.
 */
export const checkPinToken = () => {
  const pinToken = Cookies.get(COOKIE_KEY.pin_token);
  const savedPinToken = authStorage.get('xyz');
  return libCheckPinToken(pinToken, savedPinToken, AES_ENCRYPTION_SECRET_KEY);
};
